const createClass = (
  xs: $TSFixMe,
  sm: $TSFixMe,
  md: $TSFixMe,
  lg: $TSFixMe,
  className: $TSFixMe,
) => {
  let classNames = [];

  if (xs) {
    classNames.push(`col-xs-${xs}`);
  }

  if (sm) {
    classNames.push(`col-sm-${sm}`);
  }

  if (md) {
    classNames.push(`col-md-${md}`);
  }

  if (lg) {
    classNames.push(`col-lg-${lg}`);
  }

  if (className) {
    classNames.push(className);
  }

  if (classNames.length === 0) {
    classNames = ["col-sm-12"];
  }

  return classNames.join(" ");
};

type OwnProps = {
  id?: string;
  className?: string;
  style?: $TSFixMe;
  xs?: string | number;
  sm?: string | number;
  md?: string | number;
  lg?: string | number;
  children?: React.ReactNode;
};

const defaultProps: Partial<OwnProps> = {
  id: undefined,
  className: undefined,
  style: undefined,
  xs: undefined,
  sm: undefined,
  md: undefined,
  lg: undefined,
  children: undefined,
};

type Props = OwnProps & typeof defaultProps;

function Column({ id, className, style, xs, sm, md, lg, children }: Props) {
  return (
    <div
      id={id}
      className={createClass(xs, sm, md, lg, className)}
      style={style}
    >
      {children}
    </div>
  );
}

Column.defaultProps = defaultProps;

export default Column;
